export default function () {
    fetch('/wp-json/wp/v2/posts').then((response) => {
        return response.json();
    }).then((data) => {
        console.log(data);
    })
}